import React from 'react';
import { attachmentStatuses, formModes, counterpartyKind, formFieldTypes, statutoryDocTypes, companyTypes } from '../../constants';
import i18next from "../../i18n";
import { AttachmentsForm, getNewAttachmentId } from '../attachments/AttachmentsForm';
import { AttachmentForm } from '../attachments/AttachmentForm';
import { renderFormHeader } from '../document/DocumentHelpers';
import { hideModalDialog, showModalDialog } from '../ModalDialog';
import { Svg } from '../Svg';
import { getAttachmentIndicator } from './counterpartyAccreditationHelpers';
import { StatutoryDocsForm } from '../forms/StatutoryDocsForm';
export { settings } from './counterpartyAccreditationHelpers';
export { getAttachmentConfiguration } from './counterpartyAccreditationHelpers';
export { checkAttachmentsMandatoryAdding } from './counterpartyAccreditationHelpers';
export { checkAttachmentsMandatorySigning } from './counterpartyAccreditationHelpers';
export { addAttacment } from './counterpartyAccreditationHelpers';
export { getCurAttacmentsTypes } from './counterpartyAccreditationHelpers';
export function checkInputPage() {
	return true;
}
export function renderinformation() {
	const { templateFolder, formMode } = this.state;
	let attachmentBtns = [];
	if (templateFolder && formMode !== formModes.read) {
		attachmentBtns.push({
			src: "icn-download.svg",
			key: "downloadTemplate",
			title: i18next.t("downloadTemplate"),
			onClick: () => showModalDialog('modalDialog', i18next.t(i18next.t("downloadDocumentTemplate")), "",
				<StatutoryDocsForm
					key={statutoryDocTypes.template}
					docType={statutoryDocTypes.template}
					canEdit={false}
					inPopup={false}
					currentFolder={templateFolder}
				/>,
				"feedPopup middle-size"
			)
		});
	}

	return (
		<div className="doc-form-block" key="informationTab">
			{renderFormHeader.bind(this)()}
			<div className="form-block large-form doc-form x">
				<div className="form-content">
					<div className="row">
						{this.buildFormSection("mainForm")}
					</div>
				</div>
				<div className="col-lg-12 attachments-header">
					<label className="required table-label">{i18next.t("attachedFiles")}</label>
					{attachmentBtns.length > 0 &&
						<ul className="filter-header-buttons">
							{attachmentBtns.map((item, index) =>
								<li key={formMode + "attachments" + index + item.key ?? ""} className={item.classes ?? ""}>
									<button type="button" className="btn no-bg-btn" onClick={item.onClick}><Svg src={`/img/${item.src}`} /><span>{item.title}</span></button>
								</li>)}
						</ul>
					}
				</div>
				{this.renderdocs.bind(this)()}
				<div className="form-content">
					<div className="required-label"><label className="required" />{i18next.t("requiredFields")}</div>
				</div>
			</div>
		</div>
	);
}
export function renderdocs() {
	const { attachments, formMode } = this.state;
	const attachmentsChangedCallback = function (attachments) {
		const { attachmentsTypes } = this.getCurAttacmentsTypes();
		for (let i = 0; i < attachmentsTypes?.length; ++i) {
			if (attachments.findIndex(a => a.documentType === attachmentsTypes[i].value) < 0) {
				attachments.push({
					id: getNewAttachmentId(attachments),
					state: attachmentStatuses.NotAdded,
					documentType: attachmentsTypes[i].value
				});
			}
		}
		this.setState({ attachments: attachments });
	}
	return (
		<div className="doc-form-block" key="docsTab">
			<div className="col-lg-12">
				<label>{i18next.t("additionalFiles")}</label>
			</div>
			<div className="large-form doc-form simple-request">
				{formModes.read !== formMode &&
					<div className="doc-form-info">
						<Svg src="/img/info.svg" />
						<div className="doc-form-info-text">{i18next.t("requestAttachmentsHelpText")}</div>
					</div>
				}
				<AttachmentsForm attachments={attachments} edite={formModes.read !== formMode} typesOfDocumens={this.getCurAttacmentsTypes()} getAttachmentIndicatorHandler={getAttachmentIndicator.bind(this)} changedCallback={attachmentsChangedCallback.bind(this)} />
				{formModes.read !== formMode &&
					<div className="form-group form-group__last">
						<button type="button" className="btn btn-secondary" onClick={() =>
							showModalDialog('modalDialog', i18next.t("addDocument"), "", <AttachmentForm typesOfDocumens={this.getCurAttacmentsTypes()} handleAddDocument={this.addAttacment.bind(this)} onCloseHandler={() => { hideModalDialog('modalDialog'); }} />, "feedPopup middle-form")
						}
						>{i18next.t("addDocument")}</button>
					</div>
				}
			</div>
		</div>
	);
}

export function buildFormItem(item) {
	const { prop_sxcfc_counterpartyKind, prop_sxcfc_counterpartyType } = this.state;
	if (item.Name === "prop_sxcfc_certifiedISCC" && prop_sxcfc_counterpartyKind !== counterpartyKind.Maker) {
		item.Type = formFieldTypes.empty;
	}
	if ((item.Name === "prop_sxcfc_codeIPN")) {
		if (prop_sxcfc_counterpartyType === companyTypes.Entity) {
			return;
		}
	}
	if ((item.Name === "prop_sxcfc_codeEDRPOU")) {
		if (prop_sxcfc_counterpartyType !== companyTypes.Entity) {
			return;
		}
	}
	return item;
}